import React, { useState, useEffect, useContext } from 'react';
import {
	Button,
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardMedia,
	Typography,
	Grow,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from '@material-ui/core';
import { useStyles } from './useStyles';
import { db } from '../../firebase';
import { ExpandMore } from '@material-ui/icons';
import { LanguageContext } from '../../App'

export const Project = (props) => {
	const classes = useStyles();
	const [showProject, setShowProject] = useState(false);
	const [projects, setProject] = useState([]);
	const [proyectos, setProyectos] = useState([])
	const [desarrollo, setDesarrollo] = useState([])
	const [development, setDevelopment] = useState([]);
	let contador = 1000;
	const handleClick = () => {
		setShowProject(!showProject);
	};
	const { language } = useContext(LanguageContext)

	useEffect(() => {
		db.collection('projects').onSnapshot((snapshot) =>
			setProject(snapshot.docs.map((doc) => doc.data()))
		);
		db.collection('development').onSnapshot((snapshot) =>
			setDevelopment(snapshot.docs.map((doc) => doc.data()))
		);
		db.collection('desarrollo').onSnapshot((snapshot) =>
			setDesarrollo(snapshot.docs.map((doc) => doc.data()))
		);
		db.collection('proyectos').onSnapshot((snapshot) =>
			setProyectos(snapshot.docs.map((doc) => doc.data()))
		);
	}, []);
	return (
		<Accordion>
			<AccordionSummary
				classes={{ root: classes.root, content: classes.content }}
				onClick={handleClick}
			>
				<Grow in={true} timeout={1000}>
					<ExpandMore color="secondary" />
				</Grow>
			</AccordionSummary>

			<AccordionDetails
				style={{ flexDirection: 'column', display: 'flex', backgroundColor: 'black' }}
			>
				<Typography
					variant="h4"
					color="secondary"
					className={classes.titleProject}
					align="center"
				>
				{language === 'spanish' ? 'FINALIZADOS' : 'FINISHED'}	
				</Typography>
				{showProject
					? (language === 'spanish' ? proyectos.map((key, id) => (
							<div>
								<Grow in={true} timeout={contador} key={`project-${id}`}>
									<Card className={classes.projectCard}>
										<CardActionArea href={key.link} target="_blank">
											<CardMedia
												component="img"
												image={process.env.PUBLIC_URL + key.img}
												alt={props.name}
											/>
											<CardContent className={classes.mainProject}>
												<Typography variant="h4" align="center">
													{key.title.toUpperCase()}
												</Typography>
												<Typography variant="h6">
													{key.body.toUpperCase()}
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</Grow>
							</div> 
					  )) : projects.map((key, id) => (
						<div>
							<Grow in={true} timeout={contador} key={`project-${id}`}>
								<Card className={classes.projectCard}>
									<CardActionArea href={key.link} target="_blank">
										<CardMedia
											component="img"
											image={process.env.PUBLIC_URL + key.img}
											alt={props.name}
										/>
										<CardContent className={classes.mainProject}>
											<Typography variant="h4" align="center">
												{key.title.toUpperCase()}
											</Typography>
											<Typography variant="h6">
												{key.body.toUpperCase()}
											</Typography>
										</CardContent>
									</CardActionArea>
								</Card>
							</Grow>
						</div> 
					  )))
					: ''}

				<>
					<Typography
						variant="h4"
						color="secondary"
						className={classes.titleProject}
						align="center"
					>
						{language === 'spanish' ? 'EN DESARROLLO' : 'IN DEVELOPMENT'}
					</Typography>
					{showProject
						? (language === 'spanish' ? desarrollo.map((key, id) => (
							<div>
								<Grow in={true} timeout={contador} key={`project-${id}`}>
									<Card className={classes.projectCard}>
										<CardActionArea href={key.link} target="_blank">
											<CardMedia
												component="img"
												image={process.env.PUBLIC_URL + key.img}
												alt={props.name}
											/>
											<CardContent className={classes.mainProject}>
												<Typography variant="h4" align="center">
													{key.title.toUpperCase()}
												</Typography>
												<Typography variant="h6">
													{key.body.toUpperCase()}
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</Grow>
							</div> 
					  )) : development.map((key, id) => (
						<div>
							<Grow in={true} timeout={contador} key={`project-${id}`}>
								<Card className={classes.projectCard}>
									<CardActionArea href={key.link} target="_blank">
										<CardMedia
											component="img"
											image={process.env.PUBLIC_URL + key.img}
											alt={props.name}
										/>
										<CardContent className={classes.mainProject}>
											<Typography variant="h4" align="center">
												{key.title.toUpperCase()}
											</Typography>
											<Typography variant="h6">
												{key.body.toUpperCase()}
											</Typography>
										</CardContent>
									</CardActionArea>
								</Card>
							</Grow>
						</div> 
					  )))
						: ''}
				</>
			</AccordionDetails>

			{/* <Grow in={true} timeout={1000}>
					<div style={{ textAlign: 'center' }}>
						<img
							expandIcon={process.env.PUBLIC_URL + '/images/flecha-hacia-abajo.svg'}
							className={clsx(showProject ? classes.iconClick : classes.iconArrow)}
							alt="Flecha que haciendo click muestra los proyectos"
							onClick={() => setShowProject(!showProject)}
						/>
					</div> */}
			{/* </Grow> */}
		</Accordion>
	);
};
